import { getMerchantInfo, isObj, isString } from '../index'
import { addImageView } from '@core/utils'

const DEFAULT_AVATAR = 'https://qnm.hunliji.com/Fl9DQpoof8vQmB4by99kCCD80SWw'

export const getSizedImgUrl = ({
  src = getMerchantInfo().logo_path ?? DEFAULT_AVATAR,
  width = 100,
  height = 62,
  mode,
  short,
  long
}) => {
  let suffix = ''

  switch (mode) {
    // 限制短边，长边自适应
    case 'short':
      suffix = `?imageView2/0/h/${short}`
      break
    case 'long':
      suffix = `?imageView2/0/w/${long}`
      break
    default:
      suffix = `?imageView2/1/w/${width}/h/${height}`
  }

  const index = !src ? getMerchantInfo().logo_path : src.indexOf('?')
  const url = index > -1 ? src.substring(0, index) + suffix : src + suffix

  return url
}

export const isImageMogr2 = (image = '', width, height) => {
  if (!image) {
    return
  }
  if (image.indexOf('?imageMogr2/crop') > -1) {
    return `${image}/thumbnail/${width}x${height}`
  } else {
    return addImageView(image, width, height, 2)
  }
}

const rotateList = ['Right-top', 'Right-bottom', 'Left-top', 'Left-bottom']
/**
 * 图片是否旋转
 */
export const isImageRotate = orientation => {
  return orientation && rotateList.includes(orientation.val)
}

/**
 * 获取上传图片的宽高
 */
export const getUploadedImageInfo = info => {
  const { width, height, orientation } = info
  const isRotate = isImageRotate(orientation)
  return {
    width: isRotate ? height : width,
    height: isRotate ? width : height
  }
}

export const getImageViewLink = (link, width = 400, height) => {
  if (!isString(link)) return ''

  link = getImageAutoOrientLink(link)

  const imageViewSuffix = `imageView2/2/w/${width}`

  // 有预览参数
  if (link.indexOf('imageView') > -1) {
    return link
  }

  // 有裁剪参数，则拼接裁剪和预览参数
  if (link.indexOf('imageMogr2') > -1) {
    return `${link}|${imageViewSuffix}`
  }

  // 有 ? 且后面有参数，使用 & 拼接预览参数
  if (link.indexOf('?') > -1) {
    return `${link}&${imageViewSuffix}`
  }

  // 没有 ?，使用 ? 拼接预览参数
  if (link.indexOf('?') === -1) {
    return `${link}?${imageViewSuffix}`
  }
}

export const getImageAutoOrientLink = (link, info) => {
  if (!isString(link)) return ''

  if (isObj(info)) {
    // 传了info时，根据旋转信息判断是否需要加参数，并且修正width和height  注意没有修改引用，避免多次修改
    const { orientation } = info
    if (orientation && /(Left)|(Right)/.test(orientation.val)) {
      const { width: _w, height: _h } = info
      info.height = _w
      info.width = _h
    } else {
      return link
    }
  }

  if (link.includes('imageMogr2')) {
    if (!link.includes('auto-orient')) {
      link = link.replace('imageMogr2/', 'imageMogr2/auto-orient/')
    }
  } else if (link.includes('imageView')) {
    link = link.replace('imageView', 'imageMogr2/auto-orient|imageView')
  } else if (link.includes('?')) {
    link = `${link}&${'imageMogr2/auto-orient'}`
  } else {
    link = `${link}?${'imageMogr2/auto-orient'}`
  }
  return link
}

// export const fixOrientSize = info => {
//   if (!isObj(info)) {
//     return info
//   }

//   const { orientation } = info
//   if (orientation && /(Left)|(Right)/.test(orientation.value)) {
//     const { width: _w, height: _h } = info
//     info.height = _w
//     info.width = _h
//   } else {
//     return info
//   }
// }

/**
 * 根据file获取图片宽高
 * @param {*} file
 */
export const getImageSizeByFile = file => {
  return new Promise(resolve => {
    const reader = new FileReader()
    reader.onload = function(e) {
      const data = e.target.result
      const image = new Image()
      image.onload = function() {
        const { width, height } = image
        resolve({
          width,
          height
        })
      }
      image.src = data
    }
    reader.readAsDataURL(file)
  })
}
